export default __webpack_public_path__ + "static/media/green-uncheck.98886e7c.svg";